import React, { useEffect, useRef, useState } from "react";
import "./want-by-modal.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import { Col, FormGroup, Row } from "react-bootstrap";
import Success_Modal from "../success_modal/Success_Modal";
import { Controller, useForm, useWatch } from "react-hook-form";
import classNames from "classnames";
import {
  appSetup,
  getAllPrescriptionDetails,
  getAllPrescriptionValue,
} from "../../../../features/master/masterSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  getSinglePrescription,
  postPrescription,
} from "../../../../features/prescription/prescriptionSlice";
import { getAllCart, postCart } from "../../../../features/cart/cartSlice";
import { useNavigate } from "react-router-dom";
import Error_Modal from "../success_modal/Error_Modal";
import { getFieldType, validateVisionValue } from "./validation";
import CreatableSelect from "react-select/creatable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import "./Lense_prescription_modal.css";

export function useVisionSync(
  control,
  setValue,
  getValues,
  basePath,
  setError,
  setErrormodal,
) {
  const dv = useWatch({ control, name: `${basePath}.1` }) || {};
  const nv = useWatch({ control, name: `${basePath}.2` }) || {};
  const add = useWatch({ control, name: `${basePath}.3` }) || {};

  const lock = useRef(false);
  const prev = useRef({ init: false, dv: {}, nv: {}, add: {} });

  const isAxisField = (id) => {
    return String(id).toLowerCase().includes("axis");
  };

  const formatValueNV = (value, axis = false) => {
    if (value === null || value === undefined || value === "") return "";

    if (typeof value === "string" && value.includes("/")) return value;

    const num = Number(value);
    if (isNaN(num)) return "";

    const sign = num >= 0 ? "+" : "-";
    return `${sign}${Math.abs(num).toFixed(2)}`;
  };

  const formatValue = (value) => {
    if (value === null || value === undefined || value === "") return "";

    if (typeof value === "string") return value;

    if (typeof value === "string" && /^[+-]\d+(\.\d+)?$/.test(value.trim())) {
      return value;
    }

    const num = Number(value);
    if (isNaN(num)) return "";

    if (Number.isInteger(num)) {
      return String(num);
    }

    const sign = num >= 0 ? "+" : "-";
    return `${sign}${Math.abs(num).toFixed(2)}`;
  };

  useEffect(() => {
    const cur = { dv, nv, add };

    if (!prev.current.init) {
      prev.current = {
        init: true,
        dv: { ...cur.dv },
        nv: { ...cur.nv },
        add: { ...cur.add },
      };
      return;
    }

    if (lock.current) {
      prev.current = {
        init: true,
        dv: { ...dv },
        nv: { ...nv },
        add: { ...add },
      };
      return;
    }

    const keys = new Set([
      ...Object.keys(prev.current.dv),
      ...Object.keys(prev.current.nv),
      ...Object.keys(prev.current.add),
      ...Object.keys(cur.dv),
      ...Object.keys(cur.nv),
      ...Object.keys(cur.add),
    ]);

    let updated = false;
    lock.current = true;

    for (const id of keys) {
      const prevDV = prev.current.dv[id];
      const prevNV = prev.current.nv[id];
      const prevADD = prev.current.add[id];

      const curDV = cur.dv[id];
      const curNV = cur.nv[id];
      const curADD = cur.add[id];

      const dvChanged = prevDV !== curDV;
      const nvChanged = prevNV !== curNV;
      const addChanged = prevADD !== curADD;

      const changes =
        (dvChanged ? 1 : 0) + (nvChanged ? 1 : 0) + (addChanged ? 1 : 0);

      if (changes !== 1) continue;

      const axis = isAxisField(id);

      /* ---------------- DV → NV + ADD ---------------- */
      if (dvChanged) {
        const desiredNV = curDV;
        const formattedNV = formatValue(desiredNV, axis);

        if (getValues(`${basePath}.2.${id}`) !== formattedNV) {
          setValue(`${basePath}.2.${id}`, formattedNV);
          updated = true;
        }

        const desiredADD = Number(curDV) - Number(curDV);
        const formattedADD = formatValue(desiredADD, false);

        if (getValues(`${basePath}.3.${id}`) !== formattedADD) {
          setValue(`${basePath}.3.${id}`, formattedADD);
          updated = true;
        }

        continue;
      }

      if (nvChanged) {
        if (typeof curNV === "string" && curNV.includes("/")) continue;

        if (Number(curDV) > Number(curNV)) {
          setError("NV Greater than DV is not allowed");
          setErrormodal(true);
          setValue(`${basePath}.2.${id}`, formatValueNV(0, axis));
          updated = true;
          continue;
        }

        const desiredADD = Number(curNV) - Number(curDV);
        const formattedADD = formatValueNV(desiredADD);

        if (getValues(`${basePath}.3.${id}`) !== formattedADD) {
          setValue(`${basePath}.3.${id}`, formattedADD);
          updated = true;
        }

        continue;
      }

      /* ---------------- ADD → NV ---------------- */
      if (addChanged) {
        const dvNum = Number(curDV) || 0;
        const addNum = Number(curADD) || 0;

        const desiredNV = dvNum + addNum;
        const formattedNV = formatValueNV(desiredNV, axis);

        if (getValues(`${basePath}.2.${id}`) !== formattedNV) {
          setValue(`${basePath}.2.${id}`, formattedNV);
          updated = true;
        }

        continue;
      }
    }

    prev.current = {
      init: true,
      dv: { ...(getValues(`${basePath}.1`) || {}) },
      nv: { ...(getValues(`${basePath}.2`) || {}) },
      add: { ...(getValues(`${basePath}.3`) || {}) },
    };

    lock.current = false;
  }, [dv, nv, add]);
}

const Lense_prescription_modal = ({
  product,
  variant,
  product_id,
  lensId,
  lensOptionId,
  id,
  addOnId,
  lensTypeId,
  lenseId,
  lensTypeName,
  lensName,
  lensPrice,
  lensMrp,
  onLensAdded,
  redirectToCartOnSuccess,
  ...props
}) => {
  const [successmodal, setSuccessmodal] = useState(false);
  const [errormodal, setErrormodal] = useState(false);
  const [error, setError] = useState(false);
  const [dropdownOptions, setDropdownOptions] = useState(null);
  const [type, setType] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Prescription confirmation checkbox (Continue is blocked until ticked)
  const [rxConfirmed, setRxConfirmed] = useState(false);
  const [rxError, setRxError] = useState("");

  const labels = [
    { id: 1, name: "Distance Vision (DV)" },
    { id: 2, name: "Near Vision (NV)" },
    { id: 3, name: "Addition (ADD)" },
    { id: 4, name: "Pupillary Distance (PD)" },
  ];

  const eyes = [
    {
      id: 1,
      name: "RIGHT EYE (OD)",
      headers: [
        { id: 1, name: "R-SPH" },
        { id: 2, name: "R-CYL" },
        { id: 3, name: "R-AXIS" },
        { id: 4, name: "R-VA" },
      ],
    },
    {
      id: 2,
      name: "LEFT EYE (OS)",
      headers: [
        { id: 5, name: "L-SPH" },
        { id: 6, name: "L-CYL" },
        { id: 7, name: "L-AXIS" },
        { id: 8, name: "L-VA" },
      ],
    },
  ];

  const methods = useForm({
    defaultValues: {
      pdf: "",
      vision: {
        1: { 1: {}, 2: {}, 3: {}, 4: {} },
        2: { 1: {}, 2: {}, 3: {}, 4: {} },
      },
      measurements: {
        FH: "",
        A: "",
        B: "",
        DBL: "",
      },
    },
  });

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = methods;

  const { control } = methods;

  useVisionSync(
    control,
    setValue,
    getValues,
    "vision.1",
    setError,
    setErrormodal,
  );
  useVisionSync(
    control,
    setValue,
    getValues,
    "vision.2",
    setError,
    setErrormodal,
  );

  const fileInputRef = useRef(null);
  const [filePreview, setFilePreview] = useState(null);
  const [isPdf, setIsPdf] = useState(false);

  const handleBoxClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setValue("pdf", file);
    const fileType = file.type;

    if (fileType === "application/pdf") {
      setIsPdf(true);
      const fileURL = URL.createObjectURL(file);
      setFilePreview(fileURL);
    } else if (fileType.startsWith("image/")) {
      setIsPdf(false);
      const reader = new FileReader();
      reader.onloadend = () => setFilePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const navigate = useNavigate();

  const onSubmit = async (d) => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    const formData = new FormData();

    formData.append("prescriptions_type_id", type);
    if (addOnId) formData.append("addon_id", addOnId);
    if (lenseId) formData.append("lense_product_id", lenseId);
    if (lensTypeId) formData.append("lens_type_id", lensTypeId);

    formData.append("product_id", product_id);
    formData.append("vision", JSON.stringify(d.vision));

    if (d.pdf) formData.append("pdf", d.pdf);
    if (d.b_size) formData.append("b_size", d.b_size);
    if (d.a_size) formData.append("a_size", d.a_size);
    if (d.dbl) formData.append("dbl", d.dbl);
    if (d.fh) formData.append("fh", d.fh);

    const res = await dispatch(postPrescription({ data: formData }));

    if (res.meta?.requestStatus === "fulfilled") {
      const prescriptionId = res?.payload?.data?.prescription?.id;

      if (typeof onLensAdded === "function") {
        onLensAdded(lensTypeId, {
          id: lenseId,
          name: lensName,
          price: lensPrice,
          mrp: lensMrp,
          lensTypeName,
          prescriptionId,
        });
      }

      props.onHide();
     
      setRxConfirmed(false);

      if (redirectToCartOnSuccess) {
        await addToCart(prescriptionId);
        navigate("/cart");
      } else {
        setSuccessmodal(true);
      }
    }

    setIsSubmitting(false);
  };

  const dispatch = useDispatch();
  const appsetup = useSelector((state) => state.master.app_setup);
  useEffect(() => {
    dispatch(appSetup());
  }, []);

  const prescription = useSelector(
    (state) => state.prescription.singlePrescription,
  );
  useEffect(() => {
    dispatch(getSinglePrescription({ id: id }));
  }, [id]);
  // useEffect(() => {
  //   if (prescription && prescription.Prescription_Details) {
  //     const newVision = {
  //       1: { 1: {}, 2: {}, 3: {}, 4: {} },
  //       2: { 1: {}, 2: {}, 3: {}, 4: {} },
  //     };

  //     prescription.Prescription_Details.forEach((item) => {
  //       const eyeId = item.eye_type_id;
  //       const visionTypeId = item.vission_type_id;
  //       const unitId = item.eye_unit_id;
  //       const name = item.name ?? "";

  //       if (!newVision[eyeId]) newVision[eyeId] = {};
  //       if (!newVision[eyeId][visionTypeId])
  //         newVision[eyeId][visionTypeId] = {};

  //       newVision[eyeId][visionTypeId][unitId] = name;
  //     });
  //   }
  // }, [prescription, setValue]);

  useEffect(() => {
    if (prescription) {
      if (prescription.Prescription_Details) {
        const newVision = {
          1: { 1: {}, 2: {}, 3: {}, 4: {} },
          2: { 1: {}, 2: {}, 3: {}, 4: {} },
        };

        prescription.Prescription_Details.forEach((item) => {
          const eyeId = item.eye_type_id;
          const visionTypeId = item.vission_type_id;
          const unitId = item.eye_unit_id;
          const name = item.name ?? "";

          if (!newVision[eyeId]) newVision[eyeId] = {};
          if (!newVision[eyeId][visionTypeId]) {
            newVision[eyeId][visionTypeId] = {};
          }

          newVision[eyeId][visionTypeId][unitId] = name;
        });

        setValue("vision", newVision, {
          shouldDirty: false,
          shouldValidate: false,
        });
      }

      /* ---------------- MEASUREMENTS ---------------- */
      if (prescription) {
        setValue("fh", prescription.fh ?? "", { shouldDirty: false });
        setValue("a_size", prescription.a_size ?? "", { shouldDirty: false });
        setValue("b_size", prescription.b_size ?? "", { shouldDirty: false });
        setValue("dbl", prescription.dbl ?? "", { shouldDirty: false });
      }
    }
  }, [prescription, setValue]);

  const isSignIn = useSelector((state) => state.auth.is_signin);

  const handleContinue = () => {
    if (!isSignIn) {
      props.onHide();
      navigate("/login");
      return;
    }

    
    if ((type === 1 || type === 2) && !rxConfirmed) {
      setRxError("Please confirm the above to continue.");
      return;
    }

    setRxError("");
    handleSubmit(onSubmit)();
  };

  const addToCart = async (prescription_id) => {
    try {
      const data = {
        product_id: product?.id,
        variant_id: variant?.id,
        quantity: 1,
        prescription_id,
      };
      const res = await dispatch(postCart({ data: data, isSignIn: isSignIn }));

      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(getAllCart(isSignIn));
      } else if (res.meta?.requestStatus === "rejected") {
        console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const prescriptionValues = useSelector(
    (state) => state.master.prescription_details,
  );
  const [prescriptionValue, setPrescriptionValues] = useState([]);
  const GetAllPrescriptionvalue = async (name) => {
    try {
      const response = await dispatch(getAllPrescriptionValue({ name: name }));

      if (response.meta?.requestStatus === "fulfilled") {
        const result = response.payload?.map((item) => ({
          value: item.name,
          label: item.name,
        }));

        setPrescriptionValues(result);
      }
    } catch (error) {
      console.error("API error:", error);
    }
  };

  return (
    <>
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="want_modal Lense_prescription_modal"
      >
        <Modal.Body>
          <div className="modal_sec">
            <div className="title_div">
              <h4 className="h4title">Lens Prescription</h4>
            </div>

            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
              <Nav variant="pills" className="row-column">
                <Nav.Item>
                  <Nav.Link eventKey="first" onClick={() => setType(1)}>
                    Enter Manually
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="second" onClick={() => setType(2)}>
                    Upload Prescription
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="third" onClick={() => setType(3)}>
                    Not sure?
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              <Form>
                <Tab.Content>
                  <Tab.Pane eventKey="first">
                    {type === 1 && (
                      <div className="tabdata">
                        <div className="bottom">
                          <div className="row">
                            {eyes.map((eye) => (
                              <div className="col-lg-6" key={eye.id}>
                                <div className="eye_section">
                                  {/* Header Row */}
                                  <div className="row table_header">
                                    <div className="col-sm-4 col-4">
                                      <p className="eye_spec_title">
                                        {eye.name}
                                      </p>
                                    </div>
                                    {eye.headers.map((head) => (
                                      <div
                                        className="col-2 p-1 text-center header_cell"
                                        key={head.id}
                                      >
                                        <p className="top_text">{head.name}</p>
                                      </div>
                                    ))}
                                  </div>

                                  {labels.map((label) => (
                                    <div
                                      className="row align-items-center table_row"
                                      key={label.id}
                                    >
                                      <div className="col-lg-4 col-md-4 col-sm-4 col-4 label_col">
                                        <p className="left_text">
                                          {label.name}
                                        </p>
                                      </div>

                                      {eye.headers.map((head, headIndex) => {
                                        if (label.id === 3 && headIndex > 0) {
                                          return (
                                            <div
                                              className="col-lg p-1 col-md col-sm-2 col-2 input_col"
                                              key={`${eye.id}-${label.id}-${head.id}`}
                                            />
                                          );
                                        }

                                        if (label.id === 4 && headIndex > 0) {
                                          return (
                                            <div
                                              className="col-lg p-1 col-md col-sm-2 col-2 input_col"
                                              key={`${eye.id}-${label.id}-${head.id}`}
                                            />
                                          );
                                        }

                                        const fieldName = `vision.${eye.id}.${label.id}.${head.id}`;
                                        const hasError =
                                          errors?.vision?.[eye.id]?.[
                                            label.id
                                          ]?.[head.id];

                                        return (
                                          <div
                                            className="col-lg p-1 col-md col-sm-2 col-2 input_col"
                                            key={`${eye.id}-${label.id}-${head.id}`}
                                          >
                                            <Controller
                                              name={fieldName}
                                              control={control}
                                              defaultValue=""
                                              render={({ field }) => {
                                                const options =
                                                  prescriptionValue || [];

                                                const fieldType = getFieldType(
                                                  head.name,
                                                  label.name,
                                                );

                                                const selectedOption =
                                                  options.find(
                                                    (opt) =>
                                                      opt.value === field.value,
                                                  ) ||
                                                  (field.value
                                                    ? {
                                                        label: field.value,
                                                        value: field.value,
                                                      }
                                                    : null);

                                                const handleValueChange = (
                                                  rawValue,
                                                ) => {
                                                  const formatted = validateVisionValue(
                                                    rawValue,
                                                    fieldType,
                                                    setError,
                                                    setErrormodal,
                                                  );

                                                  if (formatted === null)
                                                    return;

                                                  field.onChange(formatted);
                                                  setValue(fieldName, formatted);
                                                };

                                                return (
                                                  <CreatableSelect
                                                    onKeyDown={(e) => {
                                                      if (
                                                        e.key === "Backspace" &&
                                                        field.value
                                                      ) {
                                                        field.onChange("");
                                                        setValue(fieldName, "");
                                                      }
                                                    }}
                                                    options={options}
                                                    value={selectedOption}
                                                    onChange={(selected) => {
                                                      handleValueChange(
                                                        selected?.value,
                                                      );
                                                    }}
                                                    onCreateOption={(
                                                      inputValue,
                                                    ) => {
                                                      handleValueChange(
                                                        inputValue,
                                                      );
                                                    }}
                                                    onInputChange={(
                                                      inputValue,
                                                      { action },
                                                    ) => {
                                                      if (
                                                        action ===
                                                          "input-change" &&
                                                        inputValue
                                                      ) {
                                                        GetAllPrescriptionvalue(
                                                          inputValue,
                                                        );
                                                      }
                                                    }}
                                                    isSearchable
                                                    openMenuOnClick={false}
                                                    placeholder={head.name}
                                                    components={{
                                                      DropdownIndicator: () =>
                                                        null,
                                                      IndicatorSeparator: () =>
                                                        null,
                                                    }}
                                                    styles={{
                                                      control: (base) => ({
                                                        ...base,
                                                        border: errors[fieldName]
                                                          ? "1px solid red"
                                                          : "1px solid #ced4da",
                                                        borderRadius: "50px",
                                                        paddingLeft: "10px",
                                                        boxShadow: "none",
                                                        minHeight: "40px",
                                                      }),
                                                    }}
                                                  />
                                                );
                                              }}
                                            />
                                          </div>
                                        );
                                      })}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            ))}
                            <hr className="mt-3" />
                            <div className="row ">
                              <div className="col-md-3 col-sm-3 col-6 mb-3">
                                <div className="eye_section ">
                                  <div className="d-flex  align-items-center table_row gap-3">
                                    <div className="label_col">
                                      <p className="left_text">A Size</p>
                                    </div>
                                    <div className=" input_col">
                                      <FormGroup className="input_group">
                                        <Form.Control
                                          type="text"
                                          placeholder="A Size"
                                          style={{ border: "1px solid" }}
                                          onKeyDown={(e) => {
                                            const allowedKeys = [
                                              "Backspace",
                                              "Delete",
                                              "ArrowLeft",
                                              "ArrowRight",
                                              "Tab",
                                              ".",
                                            ];

                                            if (
                                              !allowedKeys.includes(e.key) &&
                                              !/^\d$/.test(e.key)
                                            ) {
                                              e.preventDefault();
                                            }
                                          }}
                                          {...register("a_size")}
                                        />
                                      </FormGroup>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-3 col-sm-3 col-6 mb-3">
                                <div className="eye_section ">
                                  <div className="d-flex  align-items-center table_row gap-3">
                                    <div className="label_col">
                                      <p className="left_text">B Size</p>
                                    </div>
                                    <div className=" input_col">
                                      <FormGroup className="input_group">
                                        <Form.Control
                                          type="text"
                                          placeholder={"B Size"}
                                          style={{ border: "1px solid" }}
                                          {...register("b_size", {
                                            required: false,
                                          })}
                                          onKeyDown={(e) => {
                                            const allowedKeys = [
                                              "Backspace",
                                              "Delete",
                                              "ArrowLeft",
                                              "ArrowRight",
                                              "Tab",
                                              ".",
                                            ];

                                            if (
                                              !allowedKeys.includes(e.key) &&
                                              !/^\d$/.test(e.key)
                                            ) {
                                              e.preventDefault();
                                            }
                                          }}
                                        />
                                      </FormGroup>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-3 col-sm-3 col-6 mb-3">
                                <div className="eye_section ">
                                  <div className="d-flex  align-items-center table_row gap-3">
                                    <div className="label_col">
                                      <p className="left_text">FH</p>
                                    </div>
                                    <div className=" input_col">
                                      <FormGroup className="input_group">
                                        <Form.Control
                                          type="text"
                                          placeholder={"FH"}
                                          style={{ border: "1px solid" }}
                                          {...register("fh", {
                                            required: false,
                                          })}
                                          onKeyDown={(e) => {
                                            const allowedKeys = [
                                              "Backspace",
                                              "Delete",
                                              "ArrowLeft",
                                              "ArrowRight",
                                              "Tab",
                                              ".",
                                            ];

                                            if (
                                              !allowedKeys.includes(e.key) &&
                                              !/^\d$/.test(e.key)
                                            ) {
                                              e.preventDefault();
                                            }
                                          }}
                                        />
                                      </FormGroup>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-3 col-sm-3 col-6 mb-3">
                                <div className="eye_section ">
                                  <div className="d-flex  align-items-center table_row gap-3">
                                    <div className="label_col">
                                      <p className="left_text">DBL</p>
                                    </div>
                                    <div className=" input_col">
                                      <FormGroup className="input_group">
                                        <Form.Control
                                          type="text"
                                          placeholder={"DBL"}
                                          style={{ border: "1px solid" }}
                                          {...register("dbl", {
                                            required: false,
                                          })}
                                          onKeyDown={(e) => {
                                            const allowedKeys = [
                                              "Backspace",
                                              "Delete",
                                              "ArrowLeft",
                                              "ArrowRight",
                                              "Tab",
                                              ".",
                                            ];

                                            if (
                                              !allowedKeys.includes(e.key) &&
                                              !/^\d$/.test(e.key)
                                            ) {
                                              e.preventDefault();
                                            }
                                          }}
                                        />
                                      </FormGroup>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Tab.Pane>
                  <Tab.Pane eventKey="second">
                    {type === 2 && (
                      <div className="tabdata">
                        <div className="row">
                          <div className="col-lg-6 mx-auto text-center">
                            <div className="uploadphotosec">
                              <div className="box" onClick={handleBoxClick}>
                                {filePreview ? (
                                  isPdf ? (
                                    <iframe
                                      src={filePreview}
                                      title="PDF Preview"
                                      style={{
                                        width: "100%",
                                        height: "100px",
                                        border: "none",
                                      }}
                                    />
                                  ) : (
                                    <img
                                      className="uploaded-file"
                                      src={filePreview}
                                      alt="Preview"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "contain",
                                      }}
                                    />
                                  )
                                ) : (
                                  <img
                                    className="addicon"
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/assets/images/icons/doc-add.png"
                                    }
                                    alt="Upload"
                                  />
                                )}
                              </div>

                              <input
                                type="file"
                                accept="image/*,application/pdf"
                                ref={fileInputRef}
                                style={{ display: "none" }}
                                onChange={handleFileChange}
                              />

                              <input
                                type="hidden"
                                {...register("pdf", { required: true })}
                              />

                              <p className="uploadpp">
                                Upload a photo or PDF of your prescription.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Tab.Pane>

                  <Tab.Pane eventKey="third">
                    <div className="tabdata">
                      <div className="row">
                        <div className="col-lg-7 mx-auto">
                          <div className="socialinfobox">
                            <div className="row mb-2">
                              <div className="col-4 my-auto">
                                <p className="caltxt">DM Us</p>
                              </div>
                              <div className="col-8  my-auto text-end">
                                <img
                                  className="whatsappicon"
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/assets/images/icons/whatsapp.png"
                                  }
                                  alt="whatsapp-icon"
                                />
                              </div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-4 my-auto">
                                <p className="caltxt">Call Us</p>
                              </div>
                              <div className="col-8 my-auto text-end">
                                <p className="linkp">
                                  +91 {appsetup?.contact_no}
                                </p>
                              </div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-4 my-auto">
                                <p className="caltxt">Mails Us</p>
                              </div>
                              <div className="col-8 my-auto text-end">
                                <p className="linkp">{appsetup?.email}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Form>
            </Tab.Container>

            {/* Prescription confirmation - shown just before the Continue button */}
            {(type === 1 || type === 2) && (
              <div className="rx_confirm">
                <Form.Check
                  type="checkbox"
                  id="rx_confirm_checkbox"
                  checked={rxConfirmed}
                  onChange={(e) => {
                    setRxConfirmed(e.target.checked);
                    if (e.target.checked) setRxError("");
                  }}
                  label={
                    <>
                      By clicking this box, I confirm that the prescription
                      values entered above are taken from a valid (not expired)
                      prescription issued to me, signed by a licensed
                      optometrist or ophthalmologist.{" "}
                      <FontAwesomeIcon
                        icon={faInfoCircle}
                        className="rx_info_icon"
                        title="The prescription must be valid and signed by a licensed optometrist or ophthalmologist."
                      />
                    </>
                  }
                />
                {rxError && <p className="rx_confirm_error">{rxError}</p>}
              </div>
            )}

            <div className="form-group text-center">
              <button
                className="continue-btn"
                type="button"
                onClick={handleContinue}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Adding..." : "Continue"}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Success_Modal
        link={redirectToCartOnSuccess ? "/cart" : undefined}
        show={successmodal}
        onHide={() => setSuccessmodal(false)}
        successText={"PRESCRIPTION ADDED SUCCESSFULLY"}
      />

      <Error_Modal
        link={"/cart"}
        show={errormodal}
        onHide={() => setErrormodal(false)}
        successText={error}
      />
    </>
  );
};

export default Lense_prescription_modal;